export const PRODUCT_CATALOG_SECTIONS = [
  "products",
  "product-uom",
  "product-categories",
  "product-prices",
] as const;

export type ProductCatalogSection = (typeof PRODUCT_CATALOG_SECTIONS)[number];

export function isProductCatalogSection(
  value: string | undefined,
): value is ProductCatalogSection {
  return (
    typeof value === "string" &&
    (PRODUCT_CATALOG_SECTIONS as readonly string[]).includes(value)
  );
}
